import { type UploadFileInfo } from '@progress/kendo-react-upload'
import { type TFunction } from 'i18next'
import { z } from 'zod'

import { type PathKey } from '~/apps/ninesegsAnalyzer/routes/paths'
import { exists } from '~/utils'

export const pathKey = 'dataSettings' satisfies PathKey

export const questionDataTypes = ['macromill', 'intage'] as const

export type QuestionDataType = (typeof questionDataTypes)[number]

export const createFileInfoSchema = (t: TFunction<'translation', undefined>) =>
  z.object({
    fileInfo: z
      .custom<UploadFileInfo>()
      .refine(exists, t('please_select_a_file'))
      .refine(
        (fileInfo) =>
          fileInfo?.extension === '.xlsx' || fileInfo?.extension === '.csv',
        t('file_format_is_different'),
      ),
  })

// NOTE: spa/src/apps/ninesegsAnalyzer/pages/DataSettingsPage/components/UploadFileSection.tsx
// でtypeとして使っているので必要。UIには使わない
export const fileInfoSchema = z.object({
  fileInfo: z
    .custom<UploadFileInfo>()
    .refine(exists, 'ファイルを選択してください')
    .refine(
      (fileInfo) =>
        fileInfo?.extension === '.xlsx' || fileInfo?.extension === '.csv',
      'ファイルの形式が異なります',
    ),
})
